import {
  Categories,
  CategoriesFile,
  ProductCategory,
  FileDataCategories,
  FileInfo,
  FileMetaData,
  OrderedCategory,
  ProductFile,
  INFORMATIVOS_DOC_ID,
} from './../../../shared/interfaces/upload-file-support-page';

import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  TemplateRef,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthStateService } from 'app/core/services/auth-state.service';
import { AppConstants } from 'app/app.constants';
import { FormUploadFileComponent } from './form-upload-file/form-upload-file.component';
import { CategoryManagementComponent } from './category-management/category-management.component';
import { SupportPageService } from 'app/core/services/support-page.service';
import { Subject } from 'rxjs';
import { concatMap, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmacaoModalService } from 'app/core/services/confirmacaoModal.service';
import { AuthorizationService } from 'app/core/services/authorization.service';
import { UserPermissions, UserResources } from 'app/shared/models/role';
import { TimeoutEnum } from 'app/core/enum/timeout.enum';
import { FormEditProductComponent } from './form-edit-product/form-edit-product.component';
import { FileCategoryManagementComponent, FILE_CATEGORIES_DOC_ID } from './file-category-management/file-category-management.component';
import { AgresSpinnerService } from 'app/shared/components/agres-spinner/agres-spinner.service';
import { AnalyticsService } from 'app/core/services/analytics.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CampaignsService } from 'app/core/services/campaigns.service';
import {
  CampaignFormModalResult,
  CAMPAIGN_DIALOG_PANEL_CLASS,
} from 'app/shared/models/campaign';
import { CampaignFormModalComponent } from './campaigns/campaign-form-modal/campaign-form-modal.component';
import { resolveLocalizedLink } from 'app/utils/localized-link.utils';

const CAMPAIGNS_ROUTE = '/suporte-tecnico/campanhas';
const CAMPAIGN_MODAL_WIDTH_DESKTOP = '620px';
const CAMPAIGN_MODAL_WIDTH_MOBILE = '95vw';
const TOAST_POSITION_CLASS = 'toast-top-full-width';
const CAMPAIGN_TOAST_POSITION_CLASS = TOAST_POSITION_CLASS;
const SUPPORT_FILE_TOAST_OPTIONS = {
  positionClass: TOAST_POSITION_CLASS,
  disableTimeOut: false,
};
const SUPPORT_FILE_DELETE_ERROR_KEY = 'download-support-page.error-delete-file';
const SUPPORT_FILE_NOT_FOUND_KEY =
  'download-support-page.error-category-or-language-not-found';

type FileLanguageGroup = {
  fileLanguages: string[];
  filePathBlobStorage: string;
  physicalFileName: string;
};
@Component({
  standalone: false,
  selector: 'app-download-file-page',
  templateUrl: './download-file-page.component.html',
  styleUrls: ['./download-file-page.component.scss'],
})
export class DownloadFilePageComponent implements OnInit, OnDestroy {
  languageSelected: string;
  canUpload: boolean = false;
  campaignsCount: number = 0;
  productImage: string;
  selectedDownloadLangs: { [filePath: string]: string } = {};

  selectedProduct: {
    productId?: string;
    productImg?: string;
    productName?: string;
    productCategory?: string;
    softwares?: FileMetaData[];
    guides?: FileMetaData[];
    others?: FileMetaData[];
    manuals?: FileMetaData[];
  } = {};

  selectedFile: {
    fileCategory?: string;
    fileName?: string;
    filePath?: string;
    fileVersion?: string;
    fileDate?: string;
  } = {};

  private readonly authState = inject(AuthStateService);
  private readonly campaignsService = inject(CampaignsService);
  private readonly destroy$ = new Subject<void>();
  private languageCheckInterval: NodeJS.Timeout | null = null;

  showConfirmationModal: boolean;
  confirmationModalMessage: string;
  modalTitleConfirmation: string;
  confirmationModalType: string;
  modalTranslateButtonConfirmText: string;
  modalTranslateButtonCancelText: string;

  @ViewChild('dialogTemplateDescription')
  dialogTemplateDescription!: TemplateRef<FileDataCategories>;
  @ViewChild('dialogTemplateProductData')
  dialogTemplateProductData!: TemplateRef<FileDataCategories>;

  @ViewChild('dialogTemplateSupportTechnical')
  dialogTemplateSupportTechnical!: TemplateRef<void>;
  @ViewChild('dialogTemplateInformativos')
  dialogTemplateInformativos!: TemplateRef<void>;
  categorizedProductList: OrderedCategory[] = [];
  noFiles: boolean = false;
  userId: string;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isPortuguese: boolean = false;

  /** Fixed, product-less list of "Informativos" files — shown to all clients regardless of language. */
  readonly informativosCategoryKey = INFORMATIVOS_DOC_ID;
  informativosItem: ProductFile | null = null;

  defaultImageSrc =
    './../../../../assets/images/support-page/products/default-product-tecomec.svg';

  fileDetails: { [category: string]: FileMetaData | null } = {};
  allFiles: ProductFile[] = [];

  selectedLanguageGroups: { [category: string]: (FileLanguageGroup | null)[] } =
    {};
  selectedFileDetails: {
    [category: string]: {
      file: FileMetaData | null;
      fileGroup: FileLanguageGroup | null;
    };
  } = {};

  selectedFileToDownload: string = '';
  categoriesWithFiles: string[] = [];
  selectedFiles: { [category: string]: string } = {};
  downloadingFiles: { [key: string]: boolean } = {};
  fileCategories: { key: string; label: string }[] = [];

  allFilesByCategory: { [category: string]: FileMetaData[] } = {};

  constructor(
    private readonly dialog: MatDialog,
    private readonly supportPageService: SupportPageService,
    private readonly translateService: TranslateService,
    private readonly toastr: ToastrService,
    public readonly confirmacaoModalService: ConfirmacaoModalService,
    private readonly authorizationService: AuthorizationService,
    private readonly spinnerService: AgresSpinnerService,
    private readonly analyticsService: AnalyticsService,
    private readonly router: Router,
  ) {
    this.languageSelected =
      localStorage.getItem(AppConstants.KEYS_LOCAL_STORAGE.ISO_LANG) ||
      AppConstants.LANGUAGES.PT_BR;

    const usuarioLogado = this.authState.getUser();
    this.userId = usuarioLogado?.id || '';

    if (!usuarioLogado || !usuarioLogado.id) {
      this.logout();
      this.router.navigate(['/login']);
      throw new Error('Usuário não autenticado. Efetue login novamente.');
    }
    this.userId = usuarioLogado?.id;
    this.analyticsService.sendPageView('/support-page/');
    this.analyticsService.trackEvent(
      'Accessed the support page',
      'Support_page',
    );
  }

  private logout() {
    window.sessionStorage.clear();
    window.localStorage.removeItem(AppConstants.KEYS_LOCAL_STORAGE.ROLE);
    window.localStorage.removeItem(
      AppConstants.KEYS_LOCAL_STORAGE.DATE_EXPIRES,
    );
    window.localStorage.removeItem(AppConstants.KEYS_LOCAL_STORAGE.HIDE_MODAL);
    clearInterval(this.languageCheckInterval);
    this.router.navigate(['/login']);
  }

  ngOnInit() {
    this.selectedFiles = {};
    this.selectedFileDetails = {};
    this.fetchFileCategories();
    this.fetchAllSupportFiles();
    this.fetchInformativos();
    this.startLanguageCheck();
    this.canUpload = this.authorizationService
      .gethandler()
      .permits(UserPermissions.CREATE, UserResources.USER_ADMINISTRATION);

    this.campaignsService.campaignsCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => {
        this.campaignsCount = count;
      });

    // The campaigns endpoints are admin-only: fetching as a non-admin would answer
    // 403 and surface an interceptor toast to a user who cannot act on it.
    if (this.canUpload) {
      this.campaignsService
        .list()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          error: () => {
            this.campaignsCount = 0;
          },
        });
    }

    this.isMobile = window.innerWidth <= 767;
    this.isTablet = window.innerWidth <= 1024 && window.innerWidth > 767;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.languageCheckInterval) {
      clearInterval(this.languageCheckInterval);
    }
    this.startLanguageCheck();
  }

  private readonly defaultFileCategories: { key: string; label: string }[] = [
    { key: 'softwares', label: 'SOFTWARE' },
    { key: 'guides', label: 'GUIAS' },
    { key: 'manuals', label: 'MANUAIS' },
    { key: 'others', label: 'OUTROS' },
  ];

  private fetchFileCategories(): void {
    const lang = this.languageSelected;
    this.supportPageService.getSupportFileById(FILE_CATEGORIES_DOC_ID).subscribe({
      next: (data: any) => {
        if (data && data.categories && Object.keys(data.categories).length > 0) {
          this.fileCategories = Object.entries(data.categories).map(
            ([key, labels]: [string, any]) => ({
              key,
              label: (labels[lang] || labels['ptBR'] || key).toUpperCase(),
            }),
          );
        } else {
          this.fileCategories = [...this.defaultFileCategories];
        }
      },
      error: () => {
        this.fileCategories = [...this.defaultFileCategories];
      },
    });
  }

  /** Loads the fixed "Informativos" document. Absent document means no informativos were uploaded yet. */
  private fetchInformativos(): void {
    this.supportPageService.getSupportFileById(this.informativosCategoryKey).subscribe({
      next: (data: ProductFile) => {
        this.informativosItem = data || null;
      },
      error: () => {
        this.informativosItem = null;
      },
    });
  }

  downloadFileWithLang(fileItem: FileMetaData, _lang: string) {
    const { filePath, version, fileDate, fileCategory } =
      fileItem as FileMetaData;

    const { productCategory, productId } = this.selectedProduct;

    const storagePath = `${productCategory}/${productId}/${fileCategory}/${version}/${fileDate}/${filePath}`;
    this.supportPageService.getPresignedUrl([storagePath]).subscribe((urls) => {
      const url = urls[0];
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filePath || 'download';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        });
    });
  }

private startLanguageCheck() {
  this.languageCheckInterval = setInterval(() => {
    const currentLanguage = localStorage.getItem(
      AppConstants.KEYS_LOCAL_STORAGE.ISO_LANG,
    );

    if (currentLanguage === 'ptBR') {
      this.isPortuguese = true;
    } else {
      this.isPortuguese = false;
    }

    if (currentLanguage && currentLanguage !== this.languageSelected) {
      this.fetchAllSupportFiles();
      this.languageSelected = currentLanguage;
      if (this.selectedProduct) {
        this.updateModalContent();
      }
    }
  }, TimeoutEnum.VeryShort);
}

  private getOrderedCategories(
    supportFile: Categories,
    categorizedProductList: { key: string }[],
  ): ProductCategory {
    const orderedCategories: ProductCategory = categorizedProductList
      .map((item) => item.key)
      .reduce((ordered: ProductCategory, key: string) => {
        if (supportFile.categories.hasOwnProperty(key)) {
          ordered[key] = supportFile.categories[key];
        }
        return ordered;
      }, {});

    Object.keys(supportFile.categories).forEach((key) => {
      if (!orderedCategories.hasOwnProperty(key)) {
        orderedCategories[key] = supportFile.categories[key];
      }
    });

    return orderedCategories;
  }

  updateCategoriesOnBlob() {
    this.translateService
      .get('download-support-page.update-message')
      .subscribe((res: string) => {
        this.spinnerService.toShow(res);
      });

    this.supportPageService
      .getSupportFileById('categories')
      .subscribe((supportFile: Categories) => {
        if ('categories' in supportFile) {
          const orderedCategories = this.getOrderedCategories(
            supportFile,
            this.categorizedProductList,
          );
          const updatedData = {
            id: 'categories',
            categories: orderedCategories,
          };
          this.supportPageService
            .updateSupportFile('categories', updatedData)
            .subscribe(() => {
              this.spinnerService.toHide();
            });
        }
      });
  }

  moveCategoryUp(index: number): void {
    if (index > 0) {
      const temp = this.categorizedProductList[index];
      this.categorizedProductList[index] =
        this.categorizedProductList[index - 1];
      this.categorizedProductList[index - 1] = temp;
      this.updateCategoriesOnBlob();
    }
  }

  moveCategoryDown(index: number): void {
    if (index < this.categorizedProductList.length - 1) {
      const temp = this.categorizedProductList[index];
      this.categorizedProductList[index] =
        this.categorizedProductList[index + 1];
      this.categorizedProductList[index + 1] = temp;
      this.updateCategoriesOnBlob();
    }
  }

  private fetchAllSupportFiles() {
    this.noFiles = false;

    this.translateService
      .get('global.loading.user-data-spinner')
      .subscribe((res: string) => {
        this.spinnerService.toShow(res);
      });

    this.supportPageService.getAllSupportFile().subscribe(
      (supportFiles: ProductFile[]) => {
        if (!supportFiles || supportFiles.length === 0) {
          this.noFiles = true;
          this.spinnerService.toHide();
          return;
        }

        this.supportPageService.getSupportFileById('categories').subscribe(
          (data: CategoriesFile) => {
            if (!data || !data.categories) {
              console.error(data);
              return;
            }
            const categories: { [key: string]: string }[] = [];

            for (const key in data.categories) {
              if (data.categories[key][this.languageSelected]) {
                const category = {
                  [key]: data.categories[key][this.languageSelected],
                };
                categories.push(category);
              }
            }

            const productsByCategory: Record<string, ProductFile[]> = {};

            const validSupportFiles = supportFiles.filter(
              (item): item is ProductFile => 'fileDataCategories' in item,
            );

            validSupportFiles.forEach((supportFile) => {
              const category = supportFile.productCategory;
              if (category) {
                if (!productsByCategory[category]) {
                  productsByCategory[category] = [];
                }

                if (this.hasFiles(supportFile.fileDataCategories)) {
                  productsByCategory[category].push(supportFile);
                }
              }
            });

            this.categorizedProductList = categories
              .filter(
                (category) => productsByCategory[Object.keys(category)[0]],
              )
              .map((category) => ({
                key: Object.keys(category)[0],
                label: Object.values(category)[0],
                value: productsByCategory[Object.keys(category)[0]],
              })) as OrderedCategory[];

            this.categorizedProductList.forEach((categoria) => {
              categoria.value.forEach(
                (item: ProductFile & { imageUrl?: string }) => {
                  this.getProductImageUrl(item);
                },
              );
            });
            this.spinnerService.toHide();
          },
          () => this.spinnerService.toHide(),
        );
      },
      () => {
        this.noFiles = true;
        this.spinnerService.toHide();
      },
    );
  }

  private async checkImageExists(url: string): Promise<boolean> {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      return response.ok;
    } catch {
      return false;
    }
  }

  hasFiles(fileDataCategories: FileDataCategories): boolean {
    return (
      (fileDataCategories.guides && fileDataCategories.guides.length > 0) ||
      (fileDataCategories.manuals && fileDataCategories.manuals.length > 0) ||
      (fileDataCategories.others && fileDataCategories.others.length > 0) ||
      (fileDataCategories.softwares && fileDataCategories.softwares.length > 0)
    );
  }

  getProductImageUrl(item: ProductFile & { imageUrl?: string }) {
    const url = [`images/${item.id}.png`];
    this.supportPageService.getPresignedUrl(url).subscribe(
      (data: string[]) => {
        this.checkImageExists(data[0]).then((exists: boolean) => {
          item.imageUrl = exists ? data[0] : this.defaultImageSrc;
        });
      },
      () => {
        item.imageUrl = this.defaultImageSrc;
      },
    );
  }

  private filterCategoryByLanguage(
    items: FileMetaData[],
    languageCode: string,
  ): FileMetaData[] {
    if (!items || items.length === 0) return [];

    const normalizedLanguageCode = this.normalizeLanguageCode(languageCode);
    const filteredItems = items.filter(
      (item) =>
        (item as unknown as { [key: string]: FileInfo })[
          normalizedLanguageCode
        ] ||
        (item as unknown as { [key: string]: FileInfo }).en ||
        (item as unknown as { [key: string]: FileInfo }).ptBR,
    );

    return filteredItems.map((item) => {
      const languageData: FileInfo = (
        item as unknown as { [key: string]: FileInfo }
      )[normalizedLanguageCode] ||
        (item as unknown as { [key: string]: FileInfo }).ptBR ||
        (item as unknown as { [key: string]: FileInfo }).en || {
          fileName: '',
          fileDescription: '',
          fileExtension: '',
        };

      return {
        ...item,
        fileName: languageData.fileName || 'No name available',
        description: languageData.fileDescription || 'No description available',
        selectedLanguage: normalizedLanguageCode,
        date: item.fileDate,
        version: item.fileVersion,
        filePath: item.fileName,
        fileExtension: item.fileName
          ? item.fileName.match(/\.([0-9a-z]+)$/i)?.[1] || ''
          : '',
        productLanguages: item.fileLanguages || [],
        productId: item.productId,
      } as FileMetaData;
    });
  }

  private processCategoryData(
    items: FileMetaData[],
    languageCode: string,
  ): FileMetaData[] {
    if (!items || items.length === 0) return [];

    return items.map((item) => {
      const languageData: FileInfo =
        (item as unknown as { [key: string]: FileInfo })[languageCode] ||
        (item as unknown as { [key: string]: FileInfo }).en ||
        (item.ptBR as FileInfo);

      return {
        ...item,
        fileName: languageData.fileName || 'No name available',
        fileDescription:
          languageData.fileDescription || 'No description available',
        date: item.fileDate,
        version: item.fileVersion,
        filePath: item.fileName,
        fileExtension: item.fileName
          ? item.fileName.match(/\.([0-9a-z]+)$/i)?.[1] || ''
          : '',
        productLanguages: item.fileLanguages || [],
      } as FileMetaData;
    });
  }

  private isObjectCompletelyEmpty(
    obj: Record<string, unknown>,
    track: boolean = true,
  ): boolean {
    if (track) {
      this.analyticsService.trackEvent(
        'is object completely empty',
        'is_object_empty',
      );
    }

    return Object.values(obj).every((category) =>
      Array.isArray(category)
        ? category.length === 0
        : this.isObjectCompletelyEmpty(
            category as Record<string, unknown>,
            false,
          ),
    );
  }
  allLanguages = [
    {
      code: 'ptBR',
      shortCode: 'PT',
      name: 'Português',
      flag: '../../../../../assets/images/support-page/flags/PT.png',
    },
    {
      code: 'en',
      shortCode: 'EN',
      name: 'Inglês',
      flag: '../../../../../assets/images/support-page/flags/EN.png',
    },
    {
      code: 'es',
      shortCode: 'ES',
      name: 'Espanhol',
      flag: '../../../../../assets/images/support-page/flags/ES.png',
    },
    {
      code: 'it',
      shortCode: 'IT',
      name: 'Italiano',
      flag: '../../../../../assets/images/support-page/flags/IT.png',
    },
    {
      code: 'fr',
      shortCode: 'FR',
      name: 'Francês',
      flag: '../../../../../assets/images/support-page/flags/FR.png',
    },
    {
      code: 'de',
      shortCode: 'DE',
      name: 'Alemão',
      flag: '../../../../../assets/images/support-page/flags/DE.png',
    },
    {
      code: 'pl',
      shortCode: 'PL',
      name: 'Polonês',
      flag: '../../../../../assets/images/support-page/flags/PL.png',
    },
    {
      code: 'ru',
      shortCode: 'RU',
      name: 'Russo',
      flag: '../../../../../assets/images/support-page/flags/RU.png',
    },
    {
      code: 'nl',
      shortCode: 'NL',
      name: 'Holandês',
      flag: '../../../../../assets/images/support-page/flags/NL.png',
    },
    {
      code: 'ch',
      shortCode: 'CH',
      name: 'Chinês',
      flag: '../../../../../assets/images/support-page/flags/CH.png',
    },
    {
      code: 'tr',
      shortCode: 'TR',
      name: 'Turco',
      flag: '../../../../../assets/images/support-page/flags/TR.png',
    },
    {
      code: 'ro',
      shortCode: 'RO',
      name: 'Romeno',
      flag: '../../../../../assets/images/support-page/flags/RO.png',
    },
    {
      code: 'hu',
      shortCode: 'HU',
      name: 'Húngaro',
      flag: '../../../../../assets/images/support-page/flags/HU.png',
    },
    {
      code: 'fi',
      shortCode: 'FI',
      name: 'Finlandês',
      flag: '../../../../../assets/images/support-page/flags/FI.png',
    },
  ];

  getFlagUrl(langCode: string): string {
    const langObj = this.allLanguages.find(
      (l) =>
        l.code.toLowerCase() === langCode.toLowerCase() ||
        l.shortCode.toLowerCase() === langCode.toLowerCase(),
    );
    return langObj
      ? langObj.flag
      : 'assets/images/support-page/flags/default.png';
  }

  private normalizeLanguageCode(languageCode: string): string {
    const normalizedCode = languageCode.toLowerCase();

    const languageMap: { [key: string]: string } = {
      pt_br: 'ptBR',
      'pt-br': 'ptBR',
      pt: 'ptBR',
      en_us: 'en',
      'en-us': 'en',
      en: 'en',
      es_es: 'es',
      'es-es': 'es',
      es: 'es',
      it_it: 'it',
      'it-it': 'it',
      it: 'it',
    };

    return languageMap[normalizedCode] || normalizedCode;
  }

  /**
   * Deletes one language file of a support product: its blob first, then its
   * Cosmos entry.
   *
   * @remarks
   * The order is deliberate. Removing the Cosmos entry first and then failing
   * to delete the blob hides the file from the page while its blob stays
   * orphaned in storage, with no way to retry. Deleting the blob first keeps
   * the entry visible on failure, and the blob deletion is idempotent, so a
   * retry converges once the Cosmos update succeeds.
   */
  private deleteSupportFile(
    productId: string,
    filePath: string,
    fileCategory: string,
    fileName: string,
    fileDate: string,
    fileVersion: string,
  ) {
    this.supportPageService.getSupportFileById(productId).subscribe({
      next: (product: ProductFile) => {
        const category = fileCategory as keyof FileDataCategories;
        const categoryList = product.fileDataCategories?.[category];
        if (!Array.isArray(categoryList)) {
          this.showSupportFileError(SUPPORT_FILE_NOT_FOUND_KEY);
          return;
        }

        const changed = this.removeFileEntries(
          categoryList,
          filePath,
          fileName,
          fileDate,
          fileVersion,
        );
        if (!changed) {
          this.showSupportFileError(SUPPORT_FILE_NOT_FOUND_KEY);
          return;
        }

        const remainingItems = categoryList.filter(
          (item) => item.files && item.files.length > 0,
        );
        const isCategoryEmptied = remainingItems.length === 0;
        if (isCategoryEmptied) {
          delete product.fileDataCategories[category];
        } else {
          product.fileDataCategories[category] = remainingItems;
        }

        // `filePath` is the stored `filePathBlobStorage`: deleted as-is, since
        // its category prefix may predate a product category change.
        this.supportPageService
          .deleteSupportBlob(filePath)
          .pipe(
            concatMap(() =>
              this.supportPageService.updateSupportFile(productId, product),
            ),
          )
          .subscribe({
            next: () =>
              this.onSupportFileDeleted(fileCategory, isCategoryEmptied),
            error: () =>
              this.showSupportFileError(SUPPORT_FILE_DELETE_ERROR_KEY),
          });
      },
      error: () => this.showSupportFileError(SUPPORT_FILE_DELETE_ERROR_KEY),
    });
  }

  /**
   * Removes the language file from the version entries it belongs to.
   *
   * @returns Whether any file entry was removed.
   */
  private removeFileEntries(
    categoryList: FileMetaData[],
    filePath: string,
    fileName: string,
    fileDate: string,
    fileVersion: string,
  ): boolean {
    let changed = false;

    for (const item of categoryList) {
      const isSameVersion =
        (item.fileVersion === fileVersion || item.version === fileVersion) &&
        item.fileDate === fileDate;

      if (isSameVersion && Array.isArray(item.files)) {
        const originalLength = item.files.length;
        item.files = item.files.filter(
          (file: FileLanguageGroup) =>
            file.filePathBlobStorage !== filePath &&
            file.physicalFileName !== fileName,
        );
        if (item.files.length !== originalLength) {
          changed = true;
        }
      }
    }

    return changed;
  }

  private onSupportFileDeleted(
    fileCategory: string,
    isCategoryEmptied: boolean,
  ) {
    this.translateService
      .get('download-support-page.file-successfully-deleted')
      .subscribe((res: string) => {
        this.toastr.info(res, '', SUPPORT_FILE_TOAST_OPTIONS);
      });

    if (isCategoryEmptied) {
      this.translateService
        .get('download-support-page.category-removed-last-file', {
          category: this.getCategoryName(fileCategory),
        })
        .subscribe((res: string) => {
          this.toastr.info(res, '', SUPPORT_FILE_TOAST_OPTIONS);
        });
    }

    this.fetchAllSupportFiles();
    this.fetchInformativos();

    setTimeout(() => {
      this.classDialogProductData();
    }, TimeoutEnum.Short);
  }

  private showSupportFileError(key: string) {
    this.translateService.get(key).subscribe((res: string) => {
      this.toastr.error(res, '', SUPPORT_FILE_TOAST_OPTIONS);
    });
  }

  getLanguageGroups(file: {
    files: { fileLanguages: string[] }[];
  }): { codes: string[]; displayText: string }[] {
    if (!file || !file.files || file.files.length === 0) {
      return [];
    }

    const allLanguages = file.files.flatMap((f) => f.fileLanguages);
    const uniqueLanguages = [...new Set(allLanguages)] as string[];

    return [
      {
        codes: uniqueLanguages,
        displayText: uniqueLanguages
          .map((lang) => this.getLanguageName(lang))
          .join(' - '),
      },
    ];
  }

  getUniqueLanguages(file: { files: { fileLanguages: string[] }[] }): string[] {
    if (!file || !file.files) return [];
    const allLanguages = file.files.flatMap((f) => f.fileLanguages);
    return [...new Set(allLanguages)] as string[];
  }

  downloadFile(
    file: FileMetaData,
    selectedFileGroup: {
      filePathBlobStorage: string;
      physicalFileName: string;
    },
  ) {
    if (!selectedFileGroup || !selectedFileGroup.filePathBlobStorage) {
      this.toastr.error('Selecione um grupo de idiomas válido para download.');
      return;
    }

    const downloadKey = selectedFileGroup.filePathBlobStorage;
    this.downloadingFiles[downloadKey] = true;

    this.supportPageService
      .getPresignedUrl([selectedFileGroup.filePathBlobStorage])
      .subscribe({
        next: (urls: string[]) => {
          const downloadUrl = urls[0];
          fetch(downloadUrl)
            .then((response) => {
              if (!response.ok) throw new Error('Erro ao baixar arquivo');
              return response.blob();
            })
            .then((blob) => {
              const blobUrl = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = selectedFileGroup.physicalFileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(blobUrl);
              delete this.downloadingFiles[downloadKey];
            })
            .catch((err) => {
              this.toastr.error('Falha ao baixar o arquivo');
              console.error('Erro ao baixar arquivo:', err);
              delete this.downloadingFiles[downloadKey];
            });
        },
        error: (err: unknown) => {
          this.toastr.error('Falha ao gerar link de download');
          console.error(err);
          delete this.downloadingFiles[downloadKey];
        },
      });
  }
  navigateToSiteAgres() {
    const url = resolveLocalizedLink(
      AppConstants.EXTERNAL_LINKS.COMPANY_CONTACT,
      this.languageSelected,
    );
    window.open(url, '_blank');
  }

  navigateToSiteAgresSendMaintenance() {
    window.open('https://agres.com.br/envio-manutencao', '_blank');
  }

  navigateToSiteAgresSerialNumber() {
    window.open('https://agres.com.br/numero-serie/', '_blank');
  }

  getSelectedFileName(category: string): string {
    const selectedFile = this.getFilesByCategory(category).find(
      (file) => file.filePath === this.selectedFiles[category],
    );
    return selectedFile ? selectedFile.fileName : '';
  }

  getSelectedFile(category: string): FileMetaData | null {
    if (!this.selectedFile[category]) return null;
    return (
      this.getFilesByCategory(category).find(
        (f) => f.filePath === this.selectedFile[category],
      ) || null
    );
  }

  getFileLanguageGroups(file: {
    files: { fileLanguages: string[] }[];
  }): { languages: string[]; display: string }[] {
    if (!file || !file.files || file.files.length === 0) {
      return [];
    }

    return file.files.map((fileEntry) => ({
      languages: fileEntry.fileLanguages,
      display: fileEntry.fileLanguages
        .map((lang) => this.getLanguageName(lang))
        .join(' + '),
    }));
  }

  getFileExtension(filePath: string | undefined): string {
    if (!filePath) return '';

    const match = filePath.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
    return match ? match[1].toUpperCase() : '';
  }

  getLanguageName(languageCode: string): string {
    const languageMap: { [key: string]: string } = {
      pt: 'PT',
      es: 'ES',
      it: 'IT',
      ru: 'RU',
      ro: 'RO',
      fr: 'FR',
      fi: 'FI',
      hu: 'HU',
      en: 'EN',
    };
    if (!languageCode) return 'Unknown';
    const normalized = languageCode.toString().toLowerCase();
    return languageMap[normalized] || languageCode.toUpperCase();
  }

  getUniqueFiles(files: FileMetaData[]): FileMetaData[] {
    return files.filter(
      (file, index, self) =>
        index ===
        self.findIndex(
          (f) =>
            f.fileName === file.fileName &&
            (f.version || f.fileVersion) ===
              (file.version || file.fileVersion) &&
            f.fileDate === file.fileDate,
        ),
    );
  }

  getSelectedFileVersion(category: string): string {
    const selectedFile = this.getFilesByCategory(category).find(
      (file) => file.filePath === this.selectedFiles[category],
    );
    if (selectedFile) {
      return selectedFile.version || selectedFile.fileVersion;
    }
    return '';
  }

  openModalProductData(item: ProductFile) {
    const currentLanguage = this.normalizeLanguageCode(this.languageSelected);
    this.selectedProduct = {
      productId: item.id,
      productName: item.productName,
      productImg: item.imageUrl,
      productCategory: item?.productCategory,
      softwares: this.filterCategoryByLanguage(
        item.fileDataCategories?.softwares || [],
        currentLanguage,
      ),
      guides: this.filterCategoryByLanguage(
        item.fileDataCategories?.guides || [],
        currentLanguage,
      ),
      manuals: this.filterCategoryByLanguage(
        item.fileDataCategories?.manuals || [],
        currentLanguage,
      ),
      others: this.filterCategoryByLanguage(
        item.fileDataCategories?.others || [],
        currentLanguage,
      ),
    };
    this.productImage = item.imageUrl;
    this.prepareFilesList(item);
  }

  updateModalContent() {
    if (!this.selectedProduct) return;
    const currentLanguage =
      this.languageSelected.toLowerCase() === 'pt_br'
        ? 'ptBR'
        : this.languageSelected.toLowerCase();

    this.selectedProduct = {
      productId: this.selectedProduct.productId,
      productCategory: this.selectedProduct.productCategory,
      softwares: this.processCategoryData(
        this.selectedProduct.softwares || [],
        currentLanguage,
      ),
      guides: this.processCategoryData(
        this.selectedProduct.guides || [],
        currentLanguage,
      ),
      manuals: this.processCategoryData(
        this.selectedProduct.manuals || [],
        currentLanguage,
      ),
      others: this.processCategoryData(
        this.selectedProduct.others || [],
        currentLanguage,
      ),
    };
  }

  openFileCategoryManagement() {
    const dialogRef = this.dialog.open(FileCategoryManagementComponent, {
      width: this.isMobile ? '450px' : this.isTablet ? '640px' : '67%',
      height: this.isMobile ? '90vh' : '90vh',
    });
    dialogRef.afterClosed().subscribe(() => this.fetchFileCategories());
  }

  openCategoryManagement() {
    const dialogRef = this.dialog.open(CategoryManagementComponent, {
      width: this.isMobile ? '450px' : this.isTablet ? '640px' : '67%',
      height: this.isMobile ? '90vh' : '90vh',
    });
    dialogRef.afterClosed().subscribe(() => this.fetchAllSupportFiles());
  }

  openDialog() {
    const dialogRef = this.dialog.open(FormUploadFileComponent, {
      width: this.isMobile ? '480px' : this.isTablet ? '640px' : '35%',
      height: this.isMobile ? '95vh' : '95vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchAllSupportFiles();
      this.fetchInformativos();
    });
  }

  navigateToCampaigns(): void {
    this.router.navigate([CAMPAIGNS_ROUTE]);
  }

  /** Opens the campaign form straight from the support page entry card. */
  openCreateCampaignModal(): void {
    let width = CAMPAIGN_MODAL_WIDTH_DESKTOP;

    if (this.isMobile) {
      width = CAMPAIGN_MODAL_WIDTH_MOBILE;
    }

    const dialogRef = this.dialog.open(CampaignFormModalComponent, {
      width,
      panelClass: CAMPAIGN_DIALOG_PANEL_CLASS,
      autoFocus: false,
      disableClose: true,
      data: { mode: 'create' },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: CampaignFormModalResult | undefined) => {
        if (!result) {
          return;
        }

        const message = this.translateService.instant(
          'support-campaigns.list.toast-created',
        );
        this.toastr.success(message, '', {
          positionClass: CAMPAIGN_TOAST_POSITION_CLASS,
          disableTimeOut: false,
        });
      });
  }

  openDialogProductEdit() {
    const dialogRef = this.dialog.open(FormEditProductComponent, {
      width: this.isMobile ? '480px' : this.isTablet ? '640px' : '35%',
      height: this.isMobile ? '90vh' : '93vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => this.fetchAllSupportFiles());
  }

  openModalToDeleteFile(
    file: FileMetaData,
    selectedFileGroup: FileLanguageGroup,
    category: string,
  ) {
    if (!selectedFileGroup) {
      this.toastr.error('Selecione um grupo de idiomas válido para deletar.');
      return;
    }

    this.selectedFile = {
      filePath: selectedFileGroup.filePathBlobStorage,
      fileName: selectedFileGroup.physicalFileName,
      fileCategory: category,
      fileDate: (file as FileMetaData).fileDate,
      fileVersion: (file as FileMetaData).version || file.fileVersion,
    };
    this.translateConfirmationMessage();
  }

  openDialogDescription(item: FileMetaData) {
    this.analyticsService.trackEvent(
      'open description modal',
      'open_description_modal',
    );
    this.dialog.open(this.dialogTemplateDescription, {
      width: this.isMobile ? '480px' : this.isTablet ? '640px' : '45%',
      disableClose: true,
      data: item,
    });
  }

  openDialogProductData(item: ProductFile) {
    this.analyticsService.trackEvent(
      'open product data modal',
      'open_product_data_modal',
    );
    let dialogWidth: string;
    if (this.isMobile) {
      dialogWidth = '500px';
    } else if (this.isTablet) {
      dialogWidth = '70%';
    } else {
      dialogWidth = '55%';
    }
    this.dialog.open(this.dialogTemplateProductData, {
      width: dialogWidth,
      height: this.isMobile ? '96vh' : '85vh',
      disableClose: true,
      data: {
        item,
      },
    });

    this.openModalProductData(item);
  }

  private extractPhysicalName(path: string): string {
    if (!path) return '';
    const segments = path.split('/');
    return segments[segments.length - 1];
  }

  openEditFileDialog(category: string, fileData: FileMetaData) {
    const physicalFileName =
      this.extractPhysicalName(fileData.filePath || '') || fileData.fileName;
    const fileVersion = fileData.fileVersion || fileData.version;

    const fileInputs = (fileData.files || []).map((file) => ({
      id: Math.floor(Math.random() * 100000).toString(),
      file: undefined as File | undefined,
      fileName: file.physicalFileName,
      selectedLanguages: file.fileLanguages,
    }));

    const dialogRef = this.dialog.open(FormUploadFileComponent, {
      width: '600px',
      height: '95vh',
      data: {
        mode: 'edit',
        fileData: fileData,
        category: category,
        productCategory: this.selectedProduct.productCategory,
        productId: this.selectedProduct.productId,
        physicalFileName: physicalFileName,
        physicalFileVersion: fileVersion,
        originalFilePath: fileData.filePath,
        originalData: fileData,
        fileInputs,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.fetchAllSupportFiles();
      this.fetchInformativos();
    });
  }

  openDialogInformativos() {
    let dialogWidth: string;
    if (this.isMobile) {
      dialogWidth = '500px';
    } else if (this.isTablet) {
      dialogWidth = '70%';
    } else {
      dialogWidth = '55%';
    }

    const item: ProductFile = this.informativosItem || {
      id: this.informativosCategoryKey,
      productCategory: this.informativosCategoryKey,
      productName: '',
      fileDataCategories: {},
      imageUrl: '',
    };

    this.dialog.open(this.dialogTemplateInformativos, {
      width: dialogWidth,
      height: this.isMobile ? '96vh' : '85vh',
      disableClose: true,
    });

    this.openModalProductData(item);
  }

  openDialogSupportTechnical() {
    this.dialog.open(this.dialogTemplateSupportTechnical, {
      width: this.isMobile ? '450px' : this.isTablet ? '100%' : '40%',
    });
  }

  classDialogProductData() {
    this.dialog.closeAll();
  }

  translateConfirmationMessage() {
    this.translateService
      .get('global.alert.delete-title')
      .subscribe((res: string) => {
        this.showConfirmationModal = true;
        this.confirmationModalMessage = '';
        this.modalTitleConfirmation = res;
        this.confirmationModalType = 'warning';
        this.modalTranslateButtonConfirmText = 'global.delete';
        this.modalTranslateButtonCancelText = 'global.cancel';
      });
  }

  getFileInfo(obj?: FileInfo): FileInfo {
    return obj ?? { fileName: '', fileDescription: '', fileExtension: '' };
  }

  getFilesGroupExtension(file: FileMetaData): string {
    if (!file.files?.length) {
      return '';
    }
    const extensions = file.files.map((f) =>
      (f.physicalFileName.match(/\.([0-9a-z]+)$/i)?.[1] || '').toLowerCase(),
    );
    const firstExt = extensions[0];
    const allEqual = extensions.every((ext) => ext === firstExt);
    if (allEqual) {
      return firstExt;
    }
    return '';
  }

  getDescriptionForPageLanguage(file: FileMetaData): string {
    const langMap: { [key: string]: string } = {
      pt_br: 'ptBR',
      pt: 'ptBR',
      en: 'en',
      es: 'es',
      it: 'it',
    };
    const normalized = this.languageSelected?.toLowerCase();
    const field = langMap[normalized] || normalized;
    const info =
      (file as unknown as FileInfo)[field] ||
      file['ptBR'] ||
      file['en'] ||
      file['es'] ||
      file['it'];
    if (info && (info.description || info.fileDescription)) {
      return info.description || info.fileDescription;
    }
    return '';
  }

  prepareFilesList(item: ProductFile) {
    this.categoriesWithFiles = [];
    this.allFilesByCategory = {};
    this.selectedLanguageGroups = {};

    const orderedKeys = this.fileCategories.length
      ? this.fileCategories.map((c) => c.key)
      : ['softwares', 'guides', 'manuals', 'others'];
    const productKeys = Object.keys(item.fileDataCategories || {});
    const categoryOrder = [...new Set([...orderedKeys, ...productKeys])];

    categoryOrder.forEach((category) => {
      const files: FileMetaData[] =
        (item.fileDataCategories as any)[category] || [];

      if (category === this.informativosCategoryKey) {
        files.sort((a, b) => (b.fileDate || '').localeCompare(a.fileDate || ''));
      }

      if (files.length > 0) {
        this.categoriesWithFiles.push(category);
        this.selectedLanguageGroups[category] = [];

        this.allFilesByCategory[category] = files.map((file, index) => {
          let langCode: string;
          if (this.languageSelected?.toLowerCase() === 'pt_br') {
            langCode = AppConstants.LANGUAGES.PT_BR;
          } else {
            langCode = this.languageSelected;
          }

          const langData: FileInfo = this.getFileInfo(
            (file as unknown as { [key: string]: FileInfo })[langCode] ||
              file.ptBR ||
              file.en,
          );

          this.selectedLanguageGroups[category][index] =
            file.files?.[0] || null;
          return {
            ...file,
            category,
            fileName: langData.fileName || file.fileName,
            fileDescription: langData.fileDescription || '',
            fileExtension: langData.fileExtension || '',
            date: file.fileDate,
            version: file.version || file.fileVersion,
            filePath: file.fileName,
            productLanguages: file.fileLanguages || [],
          } as FileMetaData;
        });
      }
    });
  }

  downloadFromUrl(url: string, filename: string) {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  getCategoryName(category: string): string {
    const found = this.fileCategories.find((c) => c.key === category);
    if (found) return found.label;
    const fallback: { [key: string]: string } = {
      softwares: 'SOFTWARE',
      guides: 'GUIAS',
      manuals: 'MANUAIS',
      others: 'OUTROS',
    };
    return (fallback[category] || category).toUpperCase();
  }

  getFilesByCategory(category: string): FileMetaData[] {
    return this.allFilesByCategory[category] || [];
  }

  onFileSelected(category: string) {
    this.fileDetails[category] = this.getSelectedFile(category);
  }

  confirmDeleteFile(category: string) {
    const details = this.selectedFileDetails[category];
    if (!details || !details.file || !details.fileGroup) {
      return;
    }
    this.openModalToDeleteFile(details.file, details.fileGroup, category);
  }

  onButtonAction(event: {
    action: boolean;
    type: string;
    buttonText?: string;
  }) {
    if (event.buttonText === 'Excluir' || event.buttonText === 'Delete') {
      const { filePath, fileCategory, fileName, fileDate, fileVersion } =
        this.selectedFile;

      if (
        this.selectedProduct.productId &&
        this.selectedProduct.productCategory &&
        filePath &&
        fileCategory &&
        fileName &&
        fileDate &&
        fileVersion
      ) {
        this.deleteSupportFile(
          this.selectedProduct.productId,
          filePath,
          fileCategory,
          fileName,
          fileDate,
          fileVersion,
        );
      } else {
        this.translateService
          .get('global.support-modal-error-file-missing')
          .subscribe((res: string) => {
            this.toastr.error(res, '', SUPPORT_FILE_TOAST_OPTIONS);
          });
      }
    }
  }
}
